import { RouteRecordRaw } from "vue-router"

export const learningRoutes: RouteRecordRaw[] = [
  {
		path: "/learning",
		component: () => import("@/views/learning/index.vue"),
		redirect: "/learning/parenting",
		children: [
			{
				path: "/learning/parenting",
				component: () => import("@/views/learning/parenting.vue")
			},
			{
				path: "/learning/read",
				component: () => import("@/views/learning/read.vue")
			},
			{
				path: "/learning/iMaths",
				component: () => import("@/views/learning/iMaths.vue")
			},
			{
				path: "/learning/art",
				component: () => import("@/views/learning/art/learning.vue"),
			},
		]
	},
	{
		path: "/iMath/summary",
		name: "iMathSummary",
		component: () => import("@/views/learning/iMathSummary.vue"),
	},
	{
		path: "/learning-grade",
		name: "learning-grade",
		component: () => import("@/views/learning/learningGrade.vue"),
		meta: {
			title: "iMaths逻辑思维馆"
		}
	},
	{
		path: "/learning-success",
		name: "learning-success",
		component: () => import("@/views/learning/learningPKSuccess.vue"),
		meta: {
			title: "iMaths逻辑思维馆"
		}
	},
]
